module.exports = __webpack_public_path__ + "static/img/avatar.dcd94363.png";